import React, { Component } from "react"
import PropTypes from "prop-types"

import Switch from "shared/components/switch"
import colors from "foundation/_colors.scss?variables"

const styles = {
  circle: {
    onColor: "white",
    offColor: "white",
  },

  switch: {
    onColor: colors.primaryTextColor,
    offColor: "rgba(0,0,0,0.5)",
  },
}
export default class PushNotifications extends Component {
  render() {
    return (
      <>
        <hr />
        <div className="connection-push-notifications">
          <div className="info">
            Get notifications when this Applet is active
          </div>
          <Switch
            size="normal"
            backgroundColor={styles.switch.offColor}
            backgroundColorEnabled={styles.switch.onColor}
            circleColor={styles.circle.onColor}
            circleColorEnabled={styles.circle.onColor}
            onChange={this.props.onChange}
            value={this.props.pushEnabled}
          />
        </div>
      </>
    )
  }
}

PushNotifications.propTypes = {
  pushEnabled: PropTypes.bool,
  onChange: PropTypes.func,
}
